var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7,
    width: 34,
    height: 34,
    rx: 5,
    stroke: "#E5792C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 20.9102,
    width: 10.125,
    height: 2.25,
    rx: 1,
    transform: "rotate(-45 13.25 20.9102)",
    fill: "#E5792C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.625,
    y: 22.0352,
    width: 11.5167,
    height: 2.25,
    rx: 1,
    transform: "rotate(-45 25.625 22.0352)",
    fill: "#E5792C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4658,
    y: 13.75,
    width: 11.25,
    height: 2.25,
    rx: 1,
    transform: "rotate(45 20.4658 13.75)",
    fill: "#E5792C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 13,
    width: 5.625,
    height: 2.25,
    rx: 1.125,
    fill: "#E5792C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.875,
    y: 18.625,
    width: 5.625,
    height: 2.25,
    rx: 1.125,
    transform: "rotate(-90 33.875 18.625)",
    fill: "#E5792C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 27,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#E5792C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 32,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#E5792C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.aaffddcb9331c9e597c867098dbf73eb.svg";
export { ForwardRef as ReactComponent };